import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { CodePageSkeleton } from '@atlassian/jira-skeletons';
import messages from './messages';
// Extend this for loading screen
// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => {
	const { formatMessage } = useIntl();
	return (
		<SpinnerContainer
			data-testId="software-code-code-page.ui.loading"
			aria-label={formatMessage(messages.label)}
		>
			<CodePageSkeleton />
		</SpinnerContainer>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SpinnerContainer = styled.div({
	padding: token('space.500', '40px'),
	width: '100%',
	height: 'calc(100vh - (var(--topNavigationHeight, 0px) + var(--bannerHeight, 0px)))',
	boxSizing: 'border-box',
});
